// removed by extract-text-webpack-plugin
module.exports = {"wrap-flexbox":"wrap-flexbox","wrap-center":"wrap-center","user-img-wrap":"user-img-wrap","wrap-img":"wrap-img","user-link":"user-link","signout-link":"signout-link","user-top-content":"user-top-content","user-link-black":"user-link-black"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_UserNav.scss
// module id = ./components/layouts/master/sub-header/_UserNav.scss
// module chunks = 0